const STORAGE_KEY = "powerpointId";


function safeGetItem(key: string): string | null {
  try {
    if (typeof window === "undefined" || !window.localStorage) return null;
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}


function safeSetItem(key: string, value: string): void {
  try {
    if (typeof window === "undefined" || !window.localStorage) return;
    window.localStorage.setItem(key, value);
  } catch {
    // ignore
  }
}


function safeRemoveItem(key: string): void {
  try {
    if (typeof window === "undefined" || !window.localStorage) return;
    window.localStorage.removeItem(key);
  } catch {
    // ignore
  }
}


export function setPowerpointIdLocal(id: string): void {
  if (!id) return;
  safeSetItem(STORAGE_KEY, id);
}


export function getPowerpointIdLocal(): string | null {
  return safeGetItem(STORAGE_KEY);
}

export function clearPowerpointIdLocal(): void {
  safeRemoveItem(STORAGE_KEY);
}


